import { createContext, useReducer } from 'react'
import notificationReducer from './NotificationReducer'

const NotificationContext = createContext()

export const NotificationProvider = ({ children }) => {
  const initialState = {
    notifications: [],
    notification: {},
    loading: false,
  }

  const [state, dispatch] = useReducer(notificationReducer, initialState)

  return (
    <NotificationContext.Provider
      value={{
        ...state,
        dispatch,
      }}
    >
      {children}
    </NotificationContext.Provider>
  )
}

export default NotificationContext
